import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Card,
  Input,
  Spin,
  Typography,
  Row,
  Col,
  message,
  Modal,
} from "antd";
import { SearchOutlined, InfoCircleOutlined, PlusOutlined } from "@ant-design/icons";
import axios from "axios";
// import WithdrawalForm from "./withdrawalForm"; // Form component for withdrawals

const { Title } = Typography;
const { Search } = Input;

const WithdrawalsList = () => {
  const [withdrawals, setWithdrawals] = useState([]);
  const [filteredWithdrawals, setFilteredWithdrawals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [formData, setFormData] = useState({}); // For edit data

  useEffect(() => {
    fetchWithdrawals();
  }, []);

  const fetchWithdrawals = async () => {
    try {
      setLoading(true);
      const response = await axios.get("http://93.127.203.113:5005/withdrawals");
      setWithdrawals(response.data);
      setFilteredWithdrawals(response.data);
    } catch (error) {
      message.error("Failed to fetch withdrawals.");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const lowerSearch = value.toLowerCase();
    const filtered = withdrawals.filter((record) => {
      const fieldsToSearch = [
        record.owner?.name || "",
        record.amount?.toString() || "",
        record.paymentMethod || "",
        record.remarks || "",
        record.createdAt && new Date(record.createdAt).toLocaleDateString(),
      ];
      return fieldsToSearch.some((field) =>
        field.toLowerCase().includes(lowerSearch)
      );
    });
    setFilteredWithdrawals(filtered);
  };

  const highlightText = (text, searchText) => {
    if (!searchText) return text;
    const regex = new RegExp(`(${searchText})`, "gi");
    const parts = text.toString().split(regex);
    return parts.map((part, index) =>
      regex.test(part) ? (
        <span
          key={index}
          style={{
            backgroundColor: "#fffb8f",
            fontWeight: "bold",
          }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const handleAddWithdrawal = () => {
    setFormData({});
    setIsModalVisible(true);
  };

  const handleEditWithdrawal = (record) => {
    setFormData(record);
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    setFormData({});
  };

  const columns = [
    {
      title: "Owner Name",
      dataIndex: ["owner", "name"],
      key: "ownerName",
      render: (text) => highlightText(text || "N/A", searchText),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => highlightText(`$${text.toFixed(2)}`, searchText),
    },
    {
      title: "Payment Method",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      render: (text) => highlightText(text || "N/A", searchText),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      render: (text) => highlightText(text || "N/A", searchText),
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) =>
        highlightText(
          date ? new Date(date).toLocaleDateString() : "N/A",
          searchText
        ),
    },

  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card
        style={{
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderTop: "5px solid #0c8c49",
        }}
      >
        <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
          Withdrawals
        </Title>
        <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
          <Col span={18}>
            <Search
              placeholder="Search Withdrawals"
              allowClear
              enterButton={<SearchOutlined />}
              onSearch={handleSearch}
              onChange={(e) => handleSearch(e.target.value)}
              style={{ width: "60%" }}
            />
          </Col>
          <Col span={6} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleAddWithdrawal}
              style={{
                backgroundColor: "#0c8c49",
                borderColor: "#0c8c49",
              }}
            >
              Add Withdrawal
            </Button>
          </Col>
        </Row>
        {loading ? (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Spin size="large" />
          </div>
        ) : (
          <Table
            columns={columns}
            dataSource={filteredWithdrawals}
            rowKey="withdrawalId"
            pagination={{ pageSize: 5 }}
            bordered
          />
        )}
      </Card>
{/* 
      <Modal
        title={formData.withdrawalId ? "Edit Withdrawal" : "Add Withdrawal"}
        visible={isModalVisible}
        onCancel={closeModal}
        footer={null}
        destroyOnClose
      >
        <WithdrawalForm
          formData={formData}
          setFormData={setFormData}
          closeModal={closeModal}
          refetchData={fetchWithdrawals}
        />
      </Modal> */}
    </div>
  );
};

export default WithdrawalsList;
